import { LoadablePaint } from '@confluence/loadable';

export const LazyPdfExportPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PdfExportContainer" */ '../src/PdfExport/PdfExportPage.tsx'
			)
		).PdfExportPage,
});
